export default {
  toBase64: window.Base64.toBase64,
  fromBase64: window.Base64.fromBase64,
  set: function set(key, value) {
    // const v = this.toBase64(JSON.stringify(value));
    if (window.localStorage) {
      window.localStorage.setItem(key, value);
    }
    document.cookie = "".concat(key, "=").concat(value, ";path=/;max-age=86400;samesite");
  },
  get: function get(key) {
    if (window.localStorage) {
      var value = window.localStorage.getItem(key);
      return value;
      // return value ? JSON.parse(this.fromBase64(value)) : '';
    } else {
      var _value = this.getCookie(key);
      return _value;
      // return value ? JSON.parse(this.fromBase64(value)) : '';
    }
  },
  remove: function remove(key) {
    if (window.localStorage) {
      window.localStorage.removeItem(key);
    }
    document.cookie = "".concat(key, "='';path=/;max-age=0;samesite");
  },
  getCookie: function getCookie(name) {
    var cookieValue = '';
    if (document.cookie && document.cookie != '') {
      var cookies = document.cookie.split(';');
      // eslint-disable-next-line no-plusplus
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].replace(/(^\s*)|(\s*$)/g, '');
        if (cookie.substring(0, name.length + 1) == "".concat(name, "=")) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }
};